import { oc } from '@orpc/contract';
import { z } from 'zod';
import { Id } from './common.js';
import { Code, LocalizedName } from './meta.js';
const Year = z.number().int().min(-3000).max(2200);
const RefCode = z
    .string()
    .trim()
    .min(1)
    .max(32)
    .regex(/^[A-Za-z0-9_-]+$/, 'code_format');
/**
 * Поля каждого редактируемого справочника (docs/PLAN.md, раздел 4.3).
 * id и isActive добавляет фабрика; удаления нет — только деактивация (на записи ссылаются).
 */
export const refFields = {
    issuers: z.object({
        code: RefCode.nullable(),
        name: LocalizedName,
        yearFrom: Year.nullable(),
        yearTo: Year.nullable(),
        numistaId: z.string().trim().min(1).max(100).nullable(),
    }),
    periods: z.object({
        issuerId: Id,
        name: LocalizedName,
        yearFrom: Year.nullable(),
        yearTo: Year.nullable(),
    }),
    currency_units: z.object({
        issuerId: Id.nullable(),
        name: LocalizedName,
    }),
    mints: z.object({
        issuerId: Id.nullable(),
        name: LocalizedName,
        mark: z.string().trim().max(16).nullable(),
    }),
    printers: z.object({
        issuerId: Id.nullable(),
        name: LocalizedName,
    }),
    grading_services: z.object({
        code: RefCode,
        name: LocalizedName,
        url: z.url().nullable(),
    }),
    numbering_systems: z.object({
        code: RefCode,
        name: LocalizedName,
        /** Коды типов объектов, для которых система применяется (пусто — для всех). */
        appliesTo: z.array(Code),
        /** Ссылка на номер во внешнем каталоге: {number} заменяется номером. */
        urlTemplate: z.string().max(300).nullable(),
    }),
};
export const EditableRefKind = z.enum(Object.keys(refFields));
const refErrors = {
    NOT_FOUND: { status: 404, message: 'not_found' },
    CODE_TAKEN: { status: 409, message: 'code_taken' },
};
export function refItemSchema(kind) {
    return refFields[kind].extend({ id: Id, isActive: z.boolean() });
}
/** Контракт одного справочника: чтение — всем, запись — admin и editor. */
function refRoutes(kind) {
    const fields = refFields[kind];
    const Item = refItemSchema(kind);
    return {
        list: oc
            .route({ method: 'GET', path: `/ref/${kind}` })
            .input(z.object({ includeInactive: z.stringbool().optional() }).optional())
            .output(z.array(Item)),
        create: oc
            .route({ method: 'POST', path: `/ref/${kind}` })
            .errors(refErrors)
            .input(fields)
            .output(Item),
        update: oc
            .route({ method: 'PATCH', path: `/ref/${kind}/{id}` })
            .errors(refErrors)
            .input(fields.partial().extend({ id: Id, isActive: z.boolean().optional() }))
            .output(Item),
    };
}
export const refsContract = {
    issuers: refRoutes('issuers'),
    periods: refRoutes('periods'),
    currency_units: refRoutes('currency_units'),
    mints: refRoutes('mints'),
    printers: refRoutes('printers'),
    grading_services: refRoutes('grading_services'),
    numbering_systems: refRoutes('numbering_systems'),
};
//# sourceMappingURL=refs.js.map